export default "__VITE_ASSET__BOVXTYLZ__"